import { Box, Table, TableRow } from '@sam/components';
import { IconComponent, IconType } from '../icons/IconComponent';
import { useNavigate } from 'react-router-dom';
import { Offer, Order, Project } from 'shared';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { convertWorkInstructionsIntoTableRows } from '../../utils/project/Project.utils';
import { TableHeader } from '@sam/components/src/Table/Table.types';

export const WorkInstructionOverview: React.FC<{
  isReadOnly: boolean;
  project?: Project;
  order: Order;
  offer?: Offer;
}> = ({ isReadOnly = false, order, offer, project }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  /**
   * Holds existing workInstructions as TableRows
   */
  const instructions: TableRow[] = useMemo((): TableRow[] => {
    if (!order) return [];
    return convertWorkInstructionsIntoTableRows(navigate, order, project, offer);
  }, [offer, project, navigate, order]);

  return (
    <Box
      title={
        <div className="user-create__box-title-wrapper">
          <p className="box__title">{t('pages.project.edit.instructions')}</p>
          {isReadOnly || (
            <IconComponent
              type={IconType.ADD}
              onClick={() =>
                navigate('/project/instruction', {
                  state: { project: project, order: order, offer: offer },
                })
              }
              className="user-create__box-title-wrapper__icon"
            />
          )}
        </div>
      }
    >
      <Table
        rows={instructions}
        header={
          t('pages.project.edit.instructionTableHeader', {
            returnObjects: true,
          }) as TableHeader[]
        }
      />
    </Box>
  );
};
